import React, { Component } from 'react'
import { unitsService } from '../../_services/units.service'
import { Dropdown } from 'semantic-ui-react'
import { connect } from 'react-redux'
import unitTypes from '../../_constants/unitTypes'

class AsyncWarehouseSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      defaultValue: this.props.defaultValue,
      categoryType: undefined,
      data: []
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData = () => {
    this.setState({ loading: true })
    unitsService
      .getAll(-1)
      .then(res => {
        // console.log(res.data);
        let data = res.data
        if (data) {
          data = data.filter(el => [2, 5, 8, 9].includes(el.unitType))
        }

        if (
          this.props.user &&
          [3, 8, 12, 13].includes(parseInt(this.props.user.userType, 0))
        ) {
          let selected = data.filter(el =>
            el.users.map(el => el.id).includes(this.props.user.userId)
          )[0].id

          let unit = data.filter(el => el.id === selected)[0]
          let unitType = unit.unitType
          console.log(unitType)

          let categoryType = -1
          if (unitType !== 9) {
            categoryType = unitTypes.filter(el => el.value === unitType)[0]
              .categoryType
          }

          this.props.onChange(selected, unitType, categoryType)
        }

        data = data.map(elm => ({
          text: elm.name,
          value: elm.id,
          unitType: elm.unitType
        }))

        this.setState({ data: data, loading: false, isSubmitting: false })
      })
      .catch(error => {
        this.setState({ loading: false })
        // console.log(error)
      })
  }

  async componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.state.defaultValue) {
      this.setState({ defaultValue: nextProps.defaultValue })
    }
    if (nextProps.categoryType !== this.state.categoryType) {
      this.setState({ categoryType: nextProps.categoryType }, () => {
        this.getData()
      })
    }
  }

  handleChange = e => {
    let selected = e
    this.setState({ selected: selected })

    let unit = this.state.data.filter(el => el.value === selected)[0]
    let unitType = unit.unitType

    let categoryType = -1
    if (unitType !== 9) {
      categoryType = unitTypes.filter(el => el.value === unitType)[0]
        .categoryType
    }
    // console.log(unitType, categoryType);

    this.props.onChange(selected, unitType, categoryType)
  }

  render() {
    const { data, loading, defaultValue, disabled } = this.state
    const { clearable, className } = this.props

    return (
      <Dropdown
        placeholder=""
        fluid
        search
        selection
        basic
        onChange={(e, data) => this.handleChange(data.value)}
        value={defaultValue}
        className={className}
        options={data}
        wrapSelection={false}
        selectOnBlur={false}
        searchInput={{ autoFocus: false }}
        loading={loading}
        disabled={
          disabled ||
          (this.props.user && [3, 6, 12, 13].includes(this.props.user.userType))
        }
        clearable={clearable}
      />
    )
  }
}

function mapStateToProps(state) {
  const { authentication } = state
  const { user } = authentication
  return {
    user
  }
}

const connectedAsyncWarehouseSelect = connect(mapStateToProps)(
  AsyncWarehouseSelect
)
export { connectedAsyncWarehouseSelect as AsyncWarehouseSelect }
